// Komponent nawigacji dni - wzorowany na AccommodationFullscreen DayNavigation

import React from "react";
import { useDayPlan } from "../../DayPlanProvider";

export const DayNavigation: React.FC = () => {
  const { offerDays, currentDayIndex, setCurrentDay } = useDayPlan();

  // Oblicz liczbę dni planu (wszystkie dni oferty)
  const planDaysCount = offerDays.length;

  // Helper function to format date and day name
  const formatDayInfo = (dayIndex: number) => {
    if (!offerDays[dayIndex]) {
      return { date: "", dayName: "" };
    }

    const dayData = offerDays[dayIndex];
    const date = new Date(dayData.date);

    const dayName = date.toLocaleDateString("pl-PL", { weekday: "short" });
    const dayMonth = date.toLocaleDateString("pl-PL", {
      day: "numeric",
      month: "numeric",
    });

    return {
      date: dayMonth,
      dayName: dayName.charAt(0).toUpperCase() + dayName.slice(1),
    };
  };

  return (
    <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
      {/* Kafelki dni */}
      <div className="flex items-center gap-3">
        <div className="flex gap-2">
          {offerDays.map((_, index) => {
            const { date, dayName } = formatDayInfo(index);

            return (
              <button
                key={index}
                data-testid={`day-nav-${index + 1}`}
                onClick={() => setCurrentDay(index)}
                className={`
                  px-3 py-2 rounded-lg font-medium text-xs transition-colors text-center min-w-[60px]
                  ${
                    currentDayIndex === index
                      ? "bg-blue-600 text-white"
                      : "bg-gray-50 text-gray-700 hover:bg-gray-100 border border-gray-200"
                  }
                `}
              >
                <div className="text-sm font-bold">{index + 1}</div>
                {date && (
                  <>
                    <div className="text-xs">{date}</div>
                    <div className="text-xs">{dayName}</div>
                  </>
                )}
              </button>
            );
          })}
        </div>
      </div>

      {/* Licznik dni planu */}
      <div className="flex items-center gap-4">
        <div className="flex items-center gap-1 text-sm text-gray-600 bg-gray-50 px-3 py-1 rounded-lg">
          <span>📋</span>
          <span className="font-medium">{planDaysCount} dni planu</span>
        </div>
      </div>
    </div>
  );
};
